import React from 'react';

import { CreateResetSatForm } from 'features/satManagement';
import SectionHeading from 'components/SectionHeading';

export default function ResetSatPage() {
  return (
    <div>
      <SectionHeading
        title="Reset SAT"
        subtitle="Fill the form to reset learner's SAT."
      />
      <CreateResetSatForm />
    </div>
  );
}
